import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class TokenInterceptorService implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (request.url
      .match(/.*(b1development.s3.eu-central-1.amazonaws).*/g) || request.url.match(/.*(b1development.s3.eu-central-1.amazonaws.com).*/g)) {
      return next.handle(request);
    } else {
      if (localStorage.getItem('token')) {
        const token = JSON.parse(localStorage.getItem('token')).token_val;
        request = request.clone({
          headers: request.headers.set('Authorization', `Bearer ` + token)
        });
      }
      return next.handle(request);
    }
  }

}
